// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useFormik } from "formik";
// COMPONENTS
import MUIDataTable from "mui-datatables";
import SVG from "react-inlinesvg";
import { Button, Modal, Form, Spinner } from "react-bootstrap";
import Select from 'react-select';
// CUSTOM COMPONENTS
import * as alert from "../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../redux/confirmModalRedux";
// SERVICES AND HELPERS
import * as projectSubTypeService from "../../../services/companyData/projectSubTypeService";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import ProjectSubTypeValidator from "../../../helpers/validators/TrainingSubTypeValidator";
import * as projectTypeService from "../../../services/companyData/projectTypeService";
import { getInputClasses, setToOptionModel } from "../../../helpers/helper";

var initialProjectSubType = {
    id: 0,
    projectTypeId: null,
    name: '',
    description: ''
}

const ProjectSubTypesListingPage = (props) => {
    const { showAlert, showConfirmModal, hideConfirmModal, setProcessing, auth } = props;
    const [data, setData] = useState([]);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProjectSubType, setSelectedProjectSubType] = useState(initialProjectSubType);
    const [loading, setLoading] = useState(true);
    const [projectTypes, setProjectTypes] = useState([]);
    const [selectedProjectType, setSelectedProjectType] = useState(null);

    useEffect(() => {
        loadTableData();
        loadProjectTypes();
    }, [])

    const loadProjectTypes = () => {
        projectTypeService.getProjectTypes().then(res => {
            setProjectTypes(res);
        });
    }

    const loadTableData = () => {
        projectSubTypeService.getProjectSubTypes().then(res => {
            setData(res);
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        }).finally(() => setLoading(false));
    }

    const editProjectSubType = (id) => {
        projectSubTypeService.getProjectSubTypeById(id).then(res => {
            setSelectedProjectSubType(res);
            if (res.projectTypeId) {
                let selectedProjectType = projectTypes.find(x => x.id == res.projectTypeId);
                setSelectedProjectType(setToOptionModel(selectedProjectType.name, selectedProjectType.id));
            }
            setIsModalOpen(true);
        })
    }

    const deleteProjectSubType = (id) => {
        setProcessing(true);
        projectSubTypeService.deleteProjectSubType(id).then(res => {
            showAlert({ message: res.message, variant: "success" });
            loadTableData();
            hideConfirmModal();
        })
    }

    const columns = [
        {
            name: "id",
            label: "Actions",
            options: {
                filter: false,
                sort: false,
                width: 1,
                download: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            <button
                                className="btn btn-sm btn-info font-weight-bold py-2 px-3 px-xxl-5"
                                onClick={() => editProjectSubType(data[dataIndex].id)}
                            >
                                Edit
                        </button> &nbsp;
                            <button
                                onClick={() => showConfirmModal({
                                    title: "Delete Project Sub Type",
                                    text: "Are you sure you want to delete this project sub type? <div class='info'>Deleting project type will delete all the projects related to this project sub type. Please make sure before you submit</div>",
                                    rightBtnText: "Confirm",
                                    btnAction: () => deleteProjectSubType(data[dataIndex].id)
                                })}
                                className="btn btn-sm btn-danger font-weight-bold py-2 px-3 px-xxl-5 my-1"
                            >
                                Delete
                        </button>
                        </>
                    );
                }
            },
        },
        {
            name: "name",
            label: "Project SubType Name",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "projectType",
            label: "Project Type",
            options: {
                filter: true,
                sort: true,
            }
        },
        {
            name: "description",
            label: "Description",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <>
                            {data[dataIndex].description ? data[dataIndex].description : "-"}
                        </>
                    );
                }
            }
        }
    ];

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedProjectSubType(initialProjectSubType);
        setSelectedProjectType(null);
        formik.resetForm();
    }

    const saveProjectSubType = (values, setStatus, setSubmitting) => {
        projectSubTypeService.saveProjectSubType(values).then(res => {
            showAlert({ message: res.message, variant: "success" });
            loadTableData();
            handleModalClose();
        }).catch((ex) => {
            showAlert({ message: ex.message, variant: "error" });
        })
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: selectedProjectSubType,
        validationSchema: ProjectSubTypeValidator,
        onSubmit: (values, { setStatus, setSubmitting }) => {
            saveProjectSubType(values, setStatus, setSubmitting);
        }
    });

    return (
        <div className="row" >
            <Modal centered size="lg" show={isModalOpen} onHide={handleModalClose}>
                <form className="card card-custom" onSubmit={formik.handleSubmit}>
                    <Modal.Header closeButton>
                        <Modal.Title>Project Sub Type</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="form">
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Name
                                    </label>
                                <div className="col-lg-9 col-xl-9">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <input
                                            mask="999-99-9999"
                                            placeholder="Start typing..."
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "name")}`}
                                            name="name"
                                            {...formik.getFieldProps("name")}
                                        />
                                    </div>
                                    {formik.touched.name && formik.errors.name ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.name}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Project Type
                                    </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Select
                                        isDisabled={!(auth && auth.isAdmin)}
                                        value={selectedProjectType}
                                        options={projectTypes.map(x => setToOptionModel(x.name, x.id))}
                                        onChange={selectedOption => {
                                            selectedOption = selectedOption === null ? [] : selectedOption;
                                            setSelectedProjectType(selectedOption);
                                            formik.setFieldValue("projectTypeId", selectedOption.value);
                                        }}
                                        className={`${getInputClasses(formik, "projectTypeId")}`}
                                        name="projectTypeId"
                                        placeholder="Select Project Type"
                                    />
                                    {formik.touched.projectTypeId && formik.errors.projectTypeId ? (
                                        <div className="invalid-feedback">
                                            {formik.errors.projectTypeId}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label col-xl-3 col-lg-3 col-form-label fz-mdsm fw-600">
                                    Description
                                    </label>
                                <div className="col-lg-9 col-xl-9">
                                    <div className="input-group input-group-lg input-group-solid">
                                        <Form.Control as="textarea" rows="5"
                                            placeholder="Start typing..."
                                            className={`form-control form-control-lg form-control-solid ${getInputClasses(formik, "description")}`}
                                            name="description"
                                            {...formik.getFieldProps("description")}
                                        />
                                    </div>
                                    {formik.touched.description && formik.errors.description ? (
                                        <div className="invalid-feedback display-block">
                                            {formik.errors.description}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleModalClose}>
                            Close
                    </Button>
                        <button
                            type="submit"
                            className="btn btn-success mr-2"
                            disabled={
                                formik.isSubmitting || (formik.touched && !formik.isValid)
                            }
                        >
                            Save
                        {formik.isSubmitting}
                        </button>
                    </Modal.Footer>
                </form>
            </Modal>
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Project Sub Types
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View and Manage Project Sub Types
                            </span>
                        </h3>
                        <div className="card-toolbar">
                            <button
                                onClick={() => setIsModalOpen(true)}
                                className="btn btn-success font-weight-bolder font-size-sm mr-3"
                            >
                                <span className="svg-icon svg-icon-lg svg-icon-white">
                                    <SVG
                                        src={toAbsoluteUrl(
                                            "/media/svg/icons/Code/Plus.svg"
                                        )}
                                    />
                                </span> Add Project Sub Type
                            </button>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <MUIDataTable
                            data={data}
                            columns={columns}
                            options={{
                                rowsPerPage: 25,
                                rowsPerPageOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
                                selectableRows: 'none',
                                textLabels: {
                                    body: {
                                        noMatch: loading ?
                                            <Spinner animation="border" size="lg" variant="info" /> :
                                            'Sorry, no matching records found.',
                                    },
                                }
                            }}
                        />
                    </div>
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = (state) => ({
    auth: state.auth
  })

export default connect(mapStateToProps, { ...alert.actions, ...confirmModal.actions })(ProjectSubTypesListingPage);